<template>
    <div class="sufee-login d-flex align-content-center flex-wrap">        
        <div class="container">
            <div class="login-content">
                <div class="login-logo">
                    <!-- <a href="index.html">
                        <img class="align-content" src="images/logo.png" alt="">
                    </a> -->
                    <img class="align-content" src="images/logo.png" alt="">
                </div>
                <div class="login-form">
                    <form>                        
                        <div class="form-group">
                            <label>아이디</label>
                            <input name="loginId" type="text" class="form-control" placeholder="아이디" 
                                v-model="loginData.loginId"
                                v-validate="'required|max:30'"
                                data-vv-delay="500">
                            <span v-show="errors.has('loginId')" class="c_red p-5-10">* 아이디를 입력해주세요({{ errors.first('loginId') }})</span>
                        </div>
                        <div class="form-group">
                            <label>비밀번호</label>
                            <input name="passwd" type="password" class="form-control" placeholder="비밀번호"
                                v-model="loginData.passwd"
                                v-validate="'required|max:15'"
                                data-vv-delay="500">
                            <span v-show="errors.has('passwd')" class="c_red p-5-10">* 비밀번호를 입력해주세요({{ errors.first('passwd') }})</span>
                        </div>
                        <div class="checkbox">
                            <!-- <label>
                                <input type="checkbox"> Remember Me
                            </label>
                            <label class="pull-right">
                                <a href="#">비밀번호찾기</a>
                            </label> -->

                        </div>
                        <button type="button" v-on:click="login" class="btn btn-success btn-flat m-b-30 m-t-30">로그인</button>                        
                        <div class="register-link m-t-15 text-center">                            
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>  
</template>
<script>
import ResultMessage from '../data/resultMessage'

export default {    
    name: 'KIALogin',
    data() {
        return {
            loginData: {
                loginId: '',
                passwd: '',
                code: ''
            }
        }
    },
    computed: {

    },
    methods: {
        login: function() {          
            let resultMessage = new ResultMessage();  
            this.$store.dispatch('userAccount/kiaLogin', this.loginData).then(()=>{
                this.$router.push('/temp-main');                                                
            })
            .catch(error => {
                resultMessage.buildErrorMessage(error);
                alert(resultMessage.message);
            });
        }
    }
}
</script>





// WEBPACK FOOTER //
// src/components/KIALogin.vue